import store from 'store2'

/*
  Available Keys:
    - sco:admin:colorMode
    - sco:paywall:hideTrialOption
    - sco:productBuilder:values
 */

export const localStore = store
